import { render } from "./PublishDesignerCard.vue?vue&type=template&id=1d773325"
import script from "./PublishDesignerCard.vue?vue&type=script&lang=js"
export * from "./PublishDesignerCard.vue?vue&type=script&lang=js"
script.render = render

export default script